import {ActionTree} from "vuex";
import {ContractProfileTemplateState, ContractProfileTemplate} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<ContractProfileTemplateState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/contract_profile_templates', {params: params})
        .then((response: AxiosResponse) => {
          const contractProfileTemplates: ContractProfileTemplate[] = response.data;
          commit('setContractProfileTemplates', contractProfileTemplates);
          return contractProfileTemplates;
        });
  },
  get({ rootGetters, commit }, params) {
    const id = params.id;
    delete params.id;
    return rootGetters['hcs/client'].get(`/contract_profile_templates/${id}`, { params: params })
        .then((response: AxiosResponse) => {
          return response.data as ContractProfileTemplate
        })
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/contract_profile_templates', params)
        .then((response: AxiosResponse) => {
          const contractProfileTemplate: ContractProfileTemplate = response.data;
          commit('addContractProfileTemplate', contractProfileTemplate);
          return contractProfileTemplate;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/contract_profile_templates/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const contractProfileTemplate: ContractProfileTemplate = response.data;
          commit('updateContractProfileTemplate', contractProfileTemplate);
          return contractProfileTemplate;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/contract_profile_templates/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteContractProfileTemplate', id);
        });
  }
}

export default actions;
